<script>
    import { getContext, onDestroy } from "svelte";
    import { key } from "./mapbox.js";
    import { arrayFromCoordinateDirctionary } from "../../../helpers/geo.js";
    import MapVehicleMarker from "./MapVehicleMarker.svelte";

    export let profile;
    export let location;
    export let isFollowing;
    export let shouldAnimateFollow;

    const map = getContext(key).map();

    let shouldAdjustCenter = true;
    let offset = { x: 0, y: 0 };
    let resizeTimer;

    if (typeof ResizeObserver !== "undefined") {
        const observer = new ResizeObserver(() => {
            clearTimeout(resizeTimer);

            shouldAdjustCenter = false;

            resizeTimer = setTimeout(() => {
                shouldAdjustCenter = true;
            }, 100);
        });

        observer.observe(map._container);

        onDestroy(() => {
            observer.unobserve(map._container);
        });
    }

    $: position = map.project(arrayFromCoordinateDirctionary(location));

    $: center = map.unproject({
        x: position.x - offset.x,
        y: position.y - offset.y
    });

    $: isFollowing &&
        shouldAdjustCenter &&
        (shouldAnimateFollow
            ? map.easeTo({
                  center: [center.lng, center.lat],
                  zoom: map.getZoom(),
                  duration: 300,
                  essential: true
              })
            : map.setCenter(center));

    $: style =
        `left: ${position.x.toFixed(2)}px;` +
        `top: ${position.y.toFixed(2)}px;` +
        "transform: translate(-50%, -50%) " +
        `rotate(${location.heading.toFixed(2)}deg);` +
        `background: ${profile.color}`;

    function didStartAdjustingViewport() {
        shouldAdjustCenter = false;
    }

    function didAdjustViewport() {
        position = map.project(arrayFromCoordinateDirctionary(location));
    }

    function didEndAdjustingViewport() {
        const center = map.project(map.getCenter());

        offset = {
            x: position.x - center.x,
            y: position.y - center.y
        };

        shouldAdjustCenter =
            Math.abs(offset.x) < map._containerWidth * 0.5 &&
            Math.abs(offset.y) < map._containerHeight * 0.5;
    }

    function didRequestViewportChange() {
        shouldAdjustCenter = false;

        map.on("idle", () => {
            shouldAdjustCenter = true;
        });
    }

    map.on("wheel", didStartAdjustingViewport);
    map.on("mousedown", didStartAdjustingViewport);
    map.on("mouseup", didEndAdjustingViewport);
    map.on("touchstart", didStartAdjustingViewport);
    map.on("touchend", didEndAdjustingViewport);
    map.on("zoomend", didEndAdjustingViewport);
    map.on("move", didAdjustViewport);

    window.addEventListener("map:viewport", didRequestViewportChange);

    onDestroy(() => {
        window.removeEventListener("map:viewport", didRequestViewportChange);
    });
</script>

<div class:animated={shouldAdjustCenter} class="vehicle" {style}>
    <MapVehicleMarker {profile} />
</div>

<style>
    .vehicle {
        position: absolute;
        z-index: 2;
        pointer-events: none;
    }

    .animated {
        transition: all 0.3s linear;
    }
</style>
